import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../css/chapterDetails.css";
import axios from "axios";
import config from "../includes/ConfigFile";
import { toast } from "react-toastify";

const ChapterDetail = () => {

    const { chapterId, tblPostId } = useParams();
    const navigate = useNavigate();

    const [storyData, setstoryData] = useState([]);
    const [currentChapter, setCurrentChapter] = useState(null);

    const [storyTitle, setStoryTitle] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [chapterTitle, setChapterTitle] = useState("");

    const user = JSON.parse(localStorage.getItem("user"));
    //const isUserLoggedIn = localStorage.getItem("user") !== null;

    // ⭐ Rating
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [avgRating, setAvgRating] = useState(0);
    const [totalRatings, setTotalRatings] = useState(0);

    // 🔊 Speak
    const [isSpeaking, setIsSpeaking] = useState(false);

    // ⚙️ Settings Popup
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    // 🔐 Login Modal
    const [showLoginPopup, setShowLoginPopup] = useState(false);

    // 📊 Scroll
    const [scrollProgress, setScrollProgress] = useState(0);

    const isUserLoggedIn = localStorage.getItem("user") !== null;

    // ================= 🔥 GET DATA =================
    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/GetPostsChapterDetails/${chapterId}/${tblPostId}`)
        .then(res => {
            setstoryData(res.data);

            const current = res.data.find(ch => ch.id == chapterId);
            setCurrentChapter(current || res.data[0]);

            if (current) {
                setStoryTitle(current.post_title);
                setShortDescription(current.post_short_description);
                setChapterTitle(current.chapter_no);
            }
        });
    }, [chapterId, tblPostId]);

    // ================= ⭐ GET RATING =================
    useEffect(() => {
        axios.get(`${config.BASE_URL}/api/getChapterRating/${chapterId}`)
        .then(res => {
            setAvgRating(res.data.avg_rating || 0);
            setTotalRatings(res.data.total || 0);
        });
    }, [chapterId]);

    // ================= ⭐ SAVE RATING =================
    /* const handleStarClick = (value) => {

        if (!isUserLoggedIn) {
            setShowLoginPopup(true);
            return;
        }

        setRating(value);

        axios.post(`${config.BASE_URL}/api/saveRating`, {
            chapter_id: chapterId,
            post_id: tblPostId,
            rating: value,
            type: "chapter"
        })
        .then(() => axios.get(`${config.BASE_URL}/api/getChapterRating/${chapterId}`))
        .then(res => {
            setAvgRating(res.data.avg_rating);
            setTotalRatings(res.data.total);
        });
    }; */
    const handleStarClick = async (value) => {
        try {
            if (!isUserLoggedIn) {
                setShowLoginPopup(true);
                return;
            }

            setRating(value);

            //const user = JSON.parse(localStorage.getItem("user"));

            //  SAFE PAYLOAD
            const payload = {
                chapter_id: chapterId,
                rating: value,
                type: "chapter" 
            };

            // Only send if available
            if (user?.id) payload.user_id = user.id;
            if (tblPostId) payload.post_id = tblPostId;

            const response = await axios.post(
                `${config.BASE_URL}/api/saveRating`,
                payload
            );
            const toastId = "chapter-rating-toast";
            
                        if (!toast.isActive(toastId)) {
                            if (response.data.action === "inserted") {
                                toast.success(response.data.message, { toastId });
                            } else {
                                toast.info(response.data.message, { toastId });
                            }
                        }

            //console.log("Rating Response:", response.data);

            //  Refresh rating
            const res = await axios.get(`${config.BASE_URL}/api/getChapterRating/${chapterId}`);
            setAvgRating(res.data.avg_rating || 0);
            setTotalRatings(res.data.total || 0);

        } catch (error) {
            console.error(" Rating Error:", error?.response?.data || error.message);

            toast.error("Something went wrong while saving rating!");
        }
    };

    // ================= 🔊 TEXT TO SPEECH =================
    const readBook = () => {
        const paragraphs = Array.from(document.querySelectorAll(".chapter-content p"))
            .map(p => p.innerText);

        let index = 0;

        const speak = () => {
            if (index < paragraphs.length) {
                const speech = new SpeechSynthesisUtterance(paragraphs[index]);
                speech.lang = "hi-IN";

                speech.onstart = () => setIsSpeaking(true);
                speech.onend = () => {
                    index++;
                    setTimeout(speak, 1000);
                };

                window.speechSynthesis.speak(speech);
            } else {
                setIsSpeaking(false);
            }
        };

        window.speechSynthesis.cancel();
        speak();
    };

    const stopReading = () => {
        window.speechSynthesis.cancel();
        setIsSpeaking(false);
    };

    // ================= 📊 SCROLL =================
    useEffect(() => {
        const handleScroll = () => {
            const totalHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollTop = document.documentElement.scrollTop;
            setScrollProgress((scrollTop / totalHeight) * 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // ================= 🔁 NAV =================
    const nextChapter = () => {
        navigate(`/chapter/${parseInt(chapterId) + 1}/${tblPostId}`);
        window.scrollTo(0, 0);
    };

    const previousChapter = () => {
        navigate(`/chapter/${parseInt(chapterId) - 1}/${tblPostId}`);
        window.scrollTo(0, 0);
    };

    const increaseShare = () => {
        // axios.post(`${config.BASE_URL}/api/increaseShare`, {
        //     post_id: tblPostId
        // }).catch(err => console.log(err));
         axios.get(`${config.BASE_URL}/api/increaseShare/${tblPostId}/${chapterId}`)
                .then(res => console.log("Share Count Updated"))
                .catch(err => console.error(err));
    };

    // ================= 📤 SHARE =================
    const shareUrl = `${window.location.origin}/chapter/${chapterId}/${tblPostId}`;

      const handleShare = () => {
           increaseShare();
   
           if (navigator.share) {
               navigator.share({
                   title: storyTitle,
                   text: shortDescription,
                   url: shareUrl,
               });
           } else {
               navigator.clipboard.writeText(shareUrl);
               toast.success("Link copied! 📋");
           }
       };
   
       const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(storyTitle + " " + shareUrl)}`;
       const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
       const twitterUrl = `https://twitter.com/intent/tweet?url=${shareUrl}&text=${storyTitle}`;

    return (
        <div className="chapter-detail-container">

            {/* 🔥 HEADER */}
            {/* <div className="header">
                <i className="bi bi-arrow-left back-arrow" onClick={() => navigate(-1)}></i>

                <span className="story-title">
                    {storyTitle} ❤️ {chapterTitle}
                </span>

                <div className="header-icons">

                    {/* 🔊 SPEAK */}
                    {/*
                    {!isSpeaking ? (
                        <i className="bi bi-volume-up settings-icon" onClick={readBook}></i>
                    ) : (
                        <i className="bi bi-volume-mute settings-icon" onClick={stopReading}></i>
                    )}

                    {/* ⚙️ SETTINGS */}
                    {/*
                    <i className="bi bi-gear settings-icon" onClick={() => setIsPopupOpen(true)}></i>
                </div>
            </div> */}
            {/* side header */}

                        <div className="floating-panel">

                            {/* TITLE */}
                            <div className="floating-title">
                                <span>{storyTitle}</span>
                                <small>Ch {chapterTitle}</small>
                            </div>

                            {/* SPEAK */}
                            {!isSpeaking ? (
                                <button className="floating-btn" onClick={readBook}>
                                    <i className="bi bi-volume-up"></i>
                                </button>
                            ) : (
                                <button className="floating-btn active" onClick={stopReading}>
                                    <i className="bi bi-volume-mute"></i>
                                </button>
                            )}

                            {/* SETTINGS */}
                            <button 
                                className="floating-btn"
                                onClick={() => setIsPopupOpen(true)}
                            >
                                <i className="bi bi-gear"></i>
                            </button>

                        </div>

            {/* //side header */}

            {/* 📊 PROGRESS */}
            <div className="progress-bar" style={{ width: `${scrollProgress}%` }}></div>

            {/* ⚙️ POPUP */}
            {isPopupOpen && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <h3>Settings</h3>
                        <button onClick={() => setIsPopupOpen(false)}>Close</button>
                    </div>
                </div>
            )}

            <div className="content-wrapper">

                <h3 style={{ color: "#000" }}>{chapterTitle}</h3>
                <p style={{ color: "#000" }}>{shortDescription}</p>
                    {/* seprater */}
                    {/* 1 */}
                <div style={{
                    position: "relative",
                    margin: "35px 0",
                    textAlign: "center"
                }}>

                    {/* Gradient Line */}
                    <div style={{
                        height: "2px",
                        width: "100%",
                        background: "linear-gradient(90deg, transparent, #00c6ff, #0072ff, transparent)",
                        borderRadius: "50px"
                    }}></div>

                    {/* Center Content */}
                    <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "#fff", // ⚠️ agar dark theme hai to change karna
                        padding: "5px 15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        borderRadius: "20px",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.08)"
                    }}>

                        <span style={{ fontSize: "18px" }}>📖</span>

                        <span style={{
                            fontSize: "12px",
                            letterSpacing: "2px",
                            color: "#555",
                            fontWeight: "600"
                        }}>
                            STORY
                        </span>

                    </div>

                </div>
                    


                    {/* //seprater */}

                {currentChapter && (
                    <div className="chapter-content">
                        <div dangerouslySetInnerHTML={{ __html: currentChapter.post_description }}></div>
                    </div>
                )}

                {/* 🔁 NAV */}
                <div className="chapter-footer">

                    <div className="chapter-nav-buttons">
                        <button onClick={previousChapter}>⬅ Previous</button>
                        <button onClick={nextChapter}>Next ➡</button>
                    </div>

                    {/* ⭐ RATING */}
                    <div className="rating-stars text-center mt-4">

                        <h4 style={{color:"#000"}}>⭐ Rating</h4>

                        {[1,2,3,4,5].map(star => (
                            <i
                                key={star}
                                className={`bi ${star <= (hoverRating || rating) ? "bi-star-fill" : "bi-star"}`}
                                onClick={() => handleStarClick(star)}
                                onMouseEnter={() => setHoverRating(star)}
                                onMouseLeave={() => setHoverRating(0)}
                                style={{ fontSize: "26px", color: "#FFD700", cursor: "pointer" }}
                            ></i>
                        ))}

                        <p style={{ color: "#ccc", marginTop: "8px" }}>⭐ {avgRating} ({totalRatings})</p>
                    </div>

                    {/* 📤 SHARE */}
                    {/* <div className="text-center mt-3">
                        <button onClick={handleShare} className="btn btn-primary">
                            Share 📤
                        </button>
                    </div> */}
                    <div className="mt-4 text-center">
                                            <h5 style={{color:"#000"}}>📤 Share</h5>
                    
                                            <div className="d-flex justify-content-center align-items-center gap-2 mt-2">
                    
                                                <button className="share-icon-btn" onClick={handleShare} title="Share">
                                                    <i className="bi bi-share"></i>
                                                </button>
                    
                                                <a href={whatsappUrl} target="_blank" rel="noreferrer"
                                                   onClick={increaseShare}
                                                   className="share-icon-btn whatsapp"
                                                   title="Share on WhatsApp">
                                                    <i className="bi bi-whatsapp"></i>
                                                </a>
                    
                                                <a href={facebookUrl} target="_blank" rel="noreferrer"
                                                   onClick={increaseShare}
                                                   className="share-icon-btn facebook"
                                                   title="Share on Facebook">
                                                    <i className="bi bi-facebook"></i>
                                                </a>
                    
                                                <a href={twitterUrl} target="_blank" rel="noreferrer"
                                                   onClick={increaseShare}
                                                   className="share-icon-btn twitter"
                                                   title="Share on Twitter">
                                                    <i className="bi bi-twitter-x"></i>
                                                </a>
                    
                                                <button
                                                    className="share-icon-btn copy"
                                                    title="Copy Link"
                                                    onClick={() => {
                                                        increaseShare();
                                                        navigator.clipboard.writeText(shareUrl);
                                                        toast.success("Link copied! 📋");
                                                    }}
                                                >
                                                    <i className="bi bi-link-45deg"></i>
                                                </button>
                    
                                            </div>
                                        </div>

                </div>
            </div>

            {/* 🔐 LOGIN MODAL */}
            {/* {showLoginPopup && (
                // <div className="modal show d-block">
                //     <div className="modal-dialog modal-dialog-centered">
                //         <div className="modal-content">
                //             <div className="modal-body text-center">
                //                 <p>Please login to rate ⭐</p>
                //                 <button onClick={() => window.location.href = "/signIn"}>Login</button>
                //             </div>
                //         </div>
                //     </div>
                // </div>
                <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content" style={{ color: "#000" }}>

                            <div className="modal-header">
                                <h5 className="modal-title">Login Required</h5>
                                <button className="btn-close" onClick={() => setShowLoginPopup(false)}></button>
                            </div>

                            <div className="modal-body">
                                <p>Please login to rate this chapter ⭐</p>
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowLoginPopup(false)}>
                                    Close
                                </button>

                                <button 
                                    className="btn btn-primary"
                                    onClick={() => window.location.href = "/signIn"}
                                >
                                    Login
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )} */}
            {showLoginPopup && (
    <div 
        className="modal fade show" 
        style={{ display: "block", background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }}
    >
        <div className="modal-dialog modal-dialog-centered">
            <div 
                className="modal-content shadow-lg border-0" 
                style={{ borderRadius: "12px", overflow: "hidden" }}
            >

                {/* HEADER */}
                <div 
                    className="modal-header" 
                    style={{ background: "#f8f9fa" }}
                >
                    <h5 className="modal-title fw-bold text-dark">
                        🔐 Login Required
                    </h5>

                    <button 
                        className="btn-close" 
                        onClick={() => setShowLoginPopup(false)}
                    ></button>
                </div>

                {/* BODY */}
                <div className="modal-body text-center py-4">
                    <p style={{ fontSize: "16px", color: "#555" }}>
                        Please login to rate this chapter ⭐
                    </p>
                </div>

                {/* FOOTER */}
                <div className="modal-footer justify-content-center gap-2 pb-4">

                    <button 
                        className="btn btn-outline-secondary px-4"
                        onClick={() => setShowLoginPopup(false)}
                    >
                        Close
                    </button>

                    <button 
                        className="btn btn-primary px-4"
                        style={{
                            background: "linear-gradient(135deg, #4facfe, #00f2fe)",
                            border: "none"
                        }}
                        onClick={() => window.location.href = "/signIn"}
                    >
                        Login
                    </button>

                </div>

            </div>
        </div>
    </div>
)}

        </div>
    );
};

export default ChapterDetail;